import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, CreditCard, Wifi, Grid3x3 } from "lucide-react";

const HowItWorks = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .page {
          background: linear-gradient(160deg, #253246 0%, #1e2738 100%);
          min-height: 100vh;
          font-family: 'DM Sans', sans-serif;
          color: #ffffff;
          padding: 60px 24px 100px;
        }

        .container {
          max-width: 680px;
          margin: 0 auto;
        }

        .header {
  border-bottom: 1px solid rgba(255,255,255,0.15);
  padding-bottom: 18px;   /* was 32px */
  margin-bottom: 40px;    /* slightly tighter spacing */
}

.logo {
  width: 200px;  
  display: block;           
  margin-top: 10px;
}

        .title {
          font-size: clamp(32px, 6vw, 52px);
          font-weight: 700;
          margin-bottom: 5px;
        }


        .step {
          display: flex;
          gap: 16px;
          border-bottom: 1px solid rgba(255,255,255,0.1);
          padding-bottom: 32px;
          margin-bottom: 32px;
        }

        .step-title {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 10px;
        }

        .step-text {
          font-size: 14px;
          line-height: 1.8;
          color: rgba(255,255,255,0.55);
        }

       
      `}</style>

      <div className="page">
        <div className="container">

          {/* Back Button */}
          <button
            className="flex items-center gap-1 text-white/60 hover:text-white border border-white/20 hover:border-white/40 transition-all text-base font-medium px-4 py-2 rounded-lg mb-6"
            onClick={() => navigate(-1)}
          >
            <ChevronLeft size={20} />
            Back
          </button>

          {/* Header */}
          <div className="header">

            {/* Logo */}
            <img src="YoGamesXR.png" alt="YoGamesXR Logo" className="logo" />

            <h1 className="title">How It Works</h1>
           
          </div>

          {/* Step 1 */}
          <div className="step">
            <CreditCard size={28} color="#00D9FF" />
            <div>
              <h2 className="step-title">Subscribe</h2>
              <p className="step-text">
                Dial *773# on your Econet line and choose a Daily, Weekly, or
                Monthly YoGameXR subscription. Or subscribe on
                www.yogamexr.econet.co.zw/subscription.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="step">
            <Wifi size={28} color="#00D9FF" />
            <div>
              <h2 className="step-title">Access the XR World</h2>
              <p className="step-text">
                Visit www.yogamexr.econet.co.zw/login on your mobile phone or
                using a VR Oculus headset to login and enter the YoGameXR
                platform.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="step">
            <Grid3x3 size={28} color="#00D9FF" />
            <div>
              <h2 className="step-title">Play, Compete & Win</h2>
              <p className="step-text">
                Get regular access to new and trending VR games and immersive
                content. Take part in daily VR challenges, earn XR Points, and
                stand a chance to win exciting rewards and prizes.
              </p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default HowItWorks;